<template>
  <v-app>
    <v-main>
        <nav class="rec-separator" ></nav>
        <div class="container">
          <router-view/>
        </div>
      </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  data: () => ({
    
  }),
};
</script>

<style lang="scss">
  .blueEbcPrimary {
    color: #035091;
  }
</style>